module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05acknowledgments#_idTextAnchor021"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06intro#_idTextAnchor060"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07pt1#_idTextAnchor111"
    }
  }, [_vm._v("Part I: Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08ch1#_idTextAnchor125"
    }
  }, [_vm._v("1\tChristianity in Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09ch2#_idTextAnchor344"
    }
  }, [_vm._v("2\tAncient Christianity in Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10ch3#_idTextAnchor489",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3\tEcumenism in Asia: Movements of Christian Unity")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11ch4#_idTextAnchor567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4\tEvangelicalism in Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12pt2#_idTextAnchor842",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: History")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13ch5#_idTextAnchor846",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5\t"), _c('i', [_vm._v("Missio Dei")]), _vm._v(": Christian History Envisioned as Cruciform Apostolicity")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14ch6#_idTextAnchor948",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6\tThe Century That Changed the Religious Map: 1910–2010")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15ch7#_idTextAnchor1062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7\tTime, Lectures, and Redemption: The Princeton Student Mission Lectures")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16ch8#_idTextAnchor1136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8\tWorld Christianity: Transforming Church History and Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17pt3#_idTextAnchor1262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Missiology")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18ch9#_idTextAnchor1269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9\tUnderwood, Moffett, and Korean Liberation: Making Sense of Early Korean Protestantism")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19ch10#_idTextAnchor1325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10\tThe Importance of Shandong: A Missiological Evaluation of "), _c('i', [_vm._v("Place")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20ch11#_idTextAnchor1443",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11\tFour Theorists, Three Selfs, Two Countries, One Goal: Missionary Practice in China and Korea")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21ch12#_idTextAnchor1548",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12\tMission and Migration: An Introductory Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22pt4#_idTextAnchor1665",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: Education")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23ch13#_idTextAnchor1669",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13\tMoffett, Mateer, and McClure: Three Models, Two Continents, One Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24ch14#_idTextAnchor1718",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14\tAmerican Theological Education and Mission: Henry W. Luce, William R. Harper, and the Secularization of Christian Higher Education")])]), _vm._v(" "), _c('p', {
    staticClass: "body_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25ch15#_idTextAnchor1803",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15\tAsian Theological Education: Earliest Trajectories, Contemporary Concerns")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26bibliography#_idTextAnchor1946",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27authorindex#_idTextAnchor2092",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28subjectindex#_idTextAnchor2099",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Subject Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29praise#_idTextAnchor2101",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Praise for")]), _vm._v(" Explorations in Asian Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/30author#_idTextAnchor2102",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/31brand",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Missiological Engagements")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/32moreIVP#_idTextAnchor2103",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a5e1a1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04contents.vue
// module id = 63
// module chunks = 0